import { render, staticRenderFns } from "./plataccount-payfee-details.vue?vue&type=template&id=f1164dd8&scoped=true&"
import script from "./plataccount-payfee-details.vue?vue&type=script&lang=js&"
export * from "./plataccount-payfee-details.vue?vue&type=script&lang=js&"
import style0 from "./plataccount-payfee-details.vue?vue&type=style&index=0&id=f1164dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1164dd8",
  null
  
)

export default component.exports